import { useState } from "react";
import "./FAQ.css";

function FAQ({ faqs: faqsProp }) {
  const [activeIndex, setActiveIndex] = useState(null);

  // Default = home FAQs; other pages pass their own
  const faqs = faqsProp || [
    {
      heading: "What CFO services do you offer in the UAE?",
      description: "At CFO Bridge UAE, we provide a range of CFO services tailored to meet the needs of businesses in Dubai, Abu Dhabi, and across the Middle East & North Africa (MENA) region. Our services include Virtual and Interim CFO Services, E-Invoicing Setup and Compliance, Company Setup and Winding Down, Working Capital Management, M&A and Fundraising, IPO Readiness, ERP Implementation, and AML, Corporate Tax, and VAT advisory to help businesses manage their financial strategy, compliance, and growth efficiently."
    },
    {
      heading: "What are virtual CFO services and how can they benefit my business in the UAE?",
      description: "Virtual CFO services provide businesses with remote financial leadership. We offer expert financial guidance, strategy, and decision-making support without the need for a full-time hire. This service helps businesses in the UAE reduce overheads while getting access to high-level financial expertise."
    },
    {
      heading: "What is the difference between shared CFO services and fractional CFO services?",
      description: "Shared CFO services involve multiple clients sharing the expertise of a CFO. It's ideal for businesses that need financial leadership but don't require a full-time CFO. On the other hand, fractional CFO services provide a dedicated CFO on a part-time basis, giving businesses more flexible access to financial expertise as and when needed."
    },
    {
      heading: "How can CFO outsourcing help my business in the UAE?",
      description: "Outsourcing your CFO services can provide expert financial guidance without the cost of a full-time hire. CFO outsource services from CFO Bridge allow businesses in the UAE to focus on growth while we handle financial strategy, compliance, reporting, and more."
    },
    {
      heading: "What is CFO consulting, and why should I consider it for my UAE business?",
      description: "CFO consulting provides businesses with specialized advice on financial strategy, processes, and compliance. It's ideal for businesses in the UAE looking to improve their financial systems, manage cash flow, or prepare for growth. Our team of experts helps you build a strong financial foundation."
    },
    {
      heading: "Can I hire a part-time CFO for my business in the UAE?",
      description: "Yes! At CFO Bridge, we offer part-time CFO firm services, where you can hire an experienced CFO on a part-time or flexible basis. This allows you to access high-level financial leadership without the full-time commitment, making it a cost-effective solution for many businesses in the UAE."
    },
    {
      heading: "How do fractional CFO services work?",
      description: "Fractional CFO services provide businesses in the UAE with access to a highly skilled CFO on a part-time basis. This service is ideal for companies that require strategic financial advice but don't need a full-time CFO. You'll get the expertise you need to make important financial decisions while keeping costs manageable."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">FAQ's</h2>
        <div className="faq-accordion">
          {faqs.map((faq, i) => (
            <div
              className={`faq-item ${activeIndex === i ? "active" : ""}`}
              key={i}
            >
              <button
                className="faq-question"
                onClick={() => toggleAccordion(i)}
              >
                {faq.heading}
                <span className={`faq-icon ${activeIndex === i ? "rotate" : ""}`}>
                  ▼
                </span>
              </button>
              <div
                className="faq-answer"
                style={{ maxHeight: activeIndex === i ? "500px" : "0px" }}
              >
                <p>{faq.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;